import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";

export class StudentModel extends ModelBase<StudentModel> {
    public id: string | null = null;
    public firstName: string | null = null;
    public lastName: string | null = null;
    public dob: Date | null = new Date();
    public referralStartDate: Date | null = new Date();
    public studentStatusId: string = "";
    public hasEHCP: string = "";
    public consentForPhotos: string = "";
    public providingTravel: string = "";
    public overallAim: string = "";
    public diagnosis: string = "";
    public medication: string = "";
    public homeLife: string = "";
    public hobbies: string = "";
    public behaviours: string = "";
    public diet: string = "";
    public wellbeingId: string = "";
    public involvementId: string = "";
    public emotionalRegulationMentoringProgramme: string = "";
    public receivingTargetedIntervention: boolean = false;

    constructor() {
        super();
        makeObservable(this, {
            firstName: observable,
            lastName: observable,
            dob: observable,
            referralStartDate: observable,
            studentStatusId: observable,
            hasEHCP: observable,
            consentForPhotos: observable,
            providingTravel: observable,
            overallAim: observable,
            diagnosis: observable,
            medication: observable,
            homeLife: observable,
            hobbies: observable,
            behaviours: observable,
            diet: observable,
            wellbeingId: observable,
            involvementId: observable,
            emotionalRegulationMentoringProgramme: observable,
        });
    }

    public get fullName() {
        return this.firstName?.concat(" ", this.lastName ?? "");
    }
}
